<template>
  <div>
    <div class="containerClass" :style="containerStyle">
      <div
        alt="ray vertical bottom"
        class="ray triangle_bottom"
        :style="triangle_bottom"
      ></div>

      <div
        alt="vert focus line"
        class="vertFocusLine vertFocusLine_bottom"
        :style="vertFocusLine"
      ></div>

      <div
        alt="ray horizontal"
        class="ray horizTriangle"
        :style="horizTriangle"
      ></div>

      <div
        alt="ray vertical superior"
        class="ray triangle_top"
        :style="triangle_top"
      ></div>

      <div
        alt="vert focus line"
        class="vertFocusLine vertFocusLine_top"
        :style="vertFocusLine"
      ></div>
      <div
        alt="horiz focus line"
        class="horizFocusLine horizFocusLine_top"
        :style="horizFocusLine"
      ></div>

      <div class="ray shadow d-print-none" :style="shadowStyle"></div>
    </div>
  </div>
</template>

<script>
// import Name from "../dir/file";

export default {
  name: "LightRays",
  props: {
    size: {
      type: Number,
      default: 100,
    },
    ray1Width: {
      type: Number,
      default: 100,
    },
    ray2Width: {
      type: Number,
      default: 100,
    },
  },
  data: function () {
    return {
      imgPath: "https://www.eyedock.com/images/visionSimulator/",
      vColor: "#bffffabd",
      vColorBorder: "#044ad09e",
      hColor: "#cfd6ff9e",
      hColorBorder: "#181dff8c",
      horizAnglePcnt: 7, // the width of the horizontal ray will be adjusted x% longer at the top and x% shorter at the bottom to give it an angle (based on the "size" prop)
      styles: {
        triangle_top: {
          top: 0,
          "clip-path": "polygon(0% 0%, 100% 100%, 0% 100%)",
        },
        triangle_bottom: {
          top: "50%",
          "clip-path": "polygon(0% 0%, 100% 0%, 0% 100%)",
        },
      },
    };
  },
  methods: {},
  computed: {
    theHeight: function () {
      return this.size * 0.28;
    },
    containerStyle: function () {
      return {
        width: this.size + "px",
        height: this.theHeight + "px",
      };
    },
    horizOffset: function () {
      return (this.size * this.horizAnglePcnt) / 100;
    },
    sphereWidth: function () {
      return this.ray1Width; // Math.min(this.ray2Width, this.ray1Width);
    },
    cylWidth: function () {
      return this.ray2Width; // * 1.0; // Math.max(this.ray2Width, this.ray1Width) * 1.03;
    },
    horizWidth: function () {
      return this.cylWidth + this.horizOffset;
    },
    horizTriangle: function () {
      let s = {
        width: this.horizWidth + "px",
        left: `-${this.horizOffset}px`,
        "background-color": this.hColorBorder,
        "--horizBgColor": this.hColor, // a css variable
        "--offset": this.horizOffset + "px", // a css variable
        "--doubleOffset": this.horizOffset * 2 + "px", // a css variable
        "clip-path": `polygon(0% 0%, ${
          this.horizOffset * 2
        }px 100%,  100% 50%)`,
      };
      return s;
    },
    vertFocusLine: function () {
      return {
        left: this.sphereWidth + "px",
      };
    },
    horizFocusLineAngle: function () {
      // let rtn = Math.atan(this.theHeight / this.horizOffset) * (180 / Math.PI)*2;
      // console.log(rtn);
      return 137;
    },
    horizFocusLine: function () {
      return {
        left: this.cylWidth + "px",
        transform: `rotate(${this.horizFocusLineAngle}deg)`,
      };
    },

    vertTriangle: function () {
      let s = {
        width: this.sphereWidth + "px",
        height: "50%",
        "background-color": this.vColorBorder,
        "--vertBgColor": this.vColor, // a css variable
      };
      return s;
    },
    triangle_top: function () {
      let s2 = { ...this.vertTriangle };
      // if (this.ray1Width > this.ray2Width) {
      s2["border-bottom"] = "0.5px dotted #45a7b2";
      // }
      let rtn = { ...s2, ...this.styles.triangle_top };
      return rtn;
    },
    triangle_bottom: function () {
      let s2 = { ...this.vertTriangle };
      // s2.clipPath = "polygon(0% 0%, 100% 0%, 0% 100%)";
      let rtn = { ...s2, ...this.styles.triangle_bottom };
      return rtn;
    },

    shadowStyle: function () {
      let smallerWidth = Math.min(this.ray2Width, this.ray1Width);
      return "width: " + smallerWidth * 0.85 + "px;";
    },
  },
};
</script>

<style scoped>
.containerClass {
  position: relative;
  background-color: transparent;
}

/*
	.opacity {
  opacity: 0.9;
}
*/
.ray {
  position: absolute;
  transition-duration: 0.5s;
  overflow: hidden;
  -webkit-print-color-adjust: exact !important;
  print-color-adjust: exact !important;
}

.shadow {
  height: 0px;
  background-color: transparent;
  box-shadow: 0px 0px 7px 4px #0000001a;
  left: 10%;
  top: 50%;
}

.printBkgImg {
  opacity: 0.9;
}

.horizTriangle {
  height: 70%;
  top: 15%;
}
.horizTriangle_back {
  height: 35%;
  top: 15%;
}
.horizTriangle_front {
  height: 35%;
  top: 50%;
}

.triangle_bottom::after {
  content: "";
  position: absolute;
  left: 1px;
  width: calc(100% - 2px);
  height: calc(100% - 1px);
  clip-path: polygon(0% 0%, calc(100% - 1px) 0%, 0% calc(100%));
  background-color: var(--vertBgColor);
  transition-duration: 0.5s;
}
.triangle_top::after {
  content: "";
  position: absolute;
  top: 1px;
  left: 1px;
  width: calc(100% - 2px);
  height: calc(100% - 1px);
  clip-path: polygon(0% 0%, calc(100% - 3px) 100%, 0% 100%);
  background-color: var(--vertBgColor);
  transition-duration: 0.5s;
}

.horizTriangle::after {
  content: "";
  position: absolute;
  width: calc(100% - 1px);
  height: 100%;

  background-color: var(--horizBgColor);
  transition-duration: 0.5s;
  clip-path: polygon(
    calc(0% + 1px) calc(0% + 1px),
    calc(var(--doubleOffset) + 1px) calc(100% - 1px),
    calc(100% - 3px) 50%
  );
}
.horizTriangle_back::after,
.horizTriangle_front::after {
  content: "";
  position: absolute;

  width: calc(100% - 1px);
  height: 100%;
  left: 1px;
  background-color: var(--horizBgColor);
  transition-duration: 0.5s;
}

.vertFocusLine {
  position: absolute;
  width: 1px;
  height: 50%;
  border: 1px solid #37bdff;
  transition-duration: 0.5s;
}

.vertFocusLine_bottom {
  top: 50%;
}

.horizFocusLine {
  position: absolute;
  width: 1px;
  height: 100%;
  top: 0%;
  /* transform: rotate(30deg); */
  border: 1px solid #4f64d8;
  transition-duration: 0.5s;
}
</style>
